// `/market` — the storefront. No search params of its own; the query and the
// category filter are component state, because a shared link to a filtered
// storefront is not a thing anybody has asked for and a search schema that
// nothing reads is a schema that rots.
//
// The parent owns the build-master gate and the authenticated runtime
// capability boundary. This child derives no access from env.
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/market/')({});
